import React, { Component } from 'react'
import { OverlayTrigger, Tooltip as BsTooltip } from 'react-bootstrap'
import PropTypes from 'prop-types'
import classNames from 'classnames'

class Tooltip extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
             show: props.open
        }
    }

    static defaultProps = {
        open: false,
        text: '',
        placement: "top",
        className: '',
        style: {},
        time: 0,
    }

    static propTypes = {
        text: PropTypes.string.isRequired,
        children: PropTypes.element.isRequired
    }
    
    componentDidMount() {
        const { time } = this.props;

        if(time) setTimeout(() => this.showTooltip(false), time)
    }

    showTooltip = show => this.setState({ show });

    renderHtml = () => {
        const { text } = this.props;
        
        return text;
    }

    wrapWithTooltip = (content, overlayProps) => {
        const { show } = this.state;
        const { className, style, time } = this.props;
        const tooltipStyle = { 
            ...overlayProps.style, 
            ...style, 
            display: show || !time ? 'block' : 'none' // To hide the tooltip when time end (if time was set)
        }
        
        return (
            <BsTooltip 
                className={classNames("custom-tooltip", className)} 
                {...overlayProps} 
                style={tooltipStyle}
            >
                {content}
            </BsTooltip>
        )
    }


    render() {
        const { show } = this.state;
        const { placement, children, ...otherProps } = this.props;
        const renderHtml = this.props.renderHtml || this.renderHtml;
        
        return (
            <OverlayTrigger
                defaultShow={show}
                {...otherProps}
                placement={placement}
                overlay={props => this.wrapWithTooltip(renderHtml(), props)}
            >
            {children}
          </OverlayTrigger>
        )
    }
}

export default Tooltip
